import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import './ServicesPage.scss';
import { useLocation, useNavigate } from "react-router-dom";
import Faq from "react-faq-component";
// images
import AreaData from './AreaData'
import CityList from '../HomePageCity/CitiesData'
import ReactCompareImage from "react-compare-image";
import BookAnAppointment from "../BookAnAppointment/BookAnAppointment";
import emailjs from 'emailjs-com';
import parse from 'html-react-parser';
import img11 from '../../Images/11.jpg'
import img12 from '../../Images/12.jpg'
import img22 from '../../Images/222.jpg'
import img23 from '../../Images/333.jpg'

export default function ServicesPage({ CitiePhone, locationsMain, CitiesData }) {

    const location = useLocation()
    const segs = location.pathname.split('/').filter(Boolean);
    const servicePath = '/service/' + (segs[1] || '');
    const Content = AreaData.find(a => a.Path === servicePath) || null;
    const citySlug = segs[2] || '';
    const TheCity = citySlug ? (CityList.find(c => c.url === citySlug) || null) : null;
    const CityLabel = TheCity ? `${TheCity.City}, ${TheCity.StateID}` : '';
    const ServiceName = Content ? (TheCity ? `${Content.Title} in ${CityLabel}` : Content.Title) : "Home Services";
    const ServiceDesc = Content ? (TheCity ? `${Content.Full} Serving ${CityLabel} and surrounding areas.` : Content.Full) : "Rocket Air Care — professional home services. Call 866-950-4606.";
    const navigate = useNavigate()
    const [FormSubmiting, setFormSubmiting] = useState(false);
    const [response, setResponse] = useState({});
    const url = new URL(window.location.href);
    function sendEmail(e) {
        // setFormSubmiting(true)
        setFormSubmiting(true)
        e.preventDefault();    //This is important, i'm not sure why, but the email won't send without it

        emailjs.sendForm('service_fqud6um', 'template_vdkxpnd', e.target, 'QeqW-bXHRNjRmhZ6I')
            .then((result) => {
                setFormSubmiting(false)
                navigate(`/thankscontact?url=${location.pathname + location.search}`)
            }, (error) => {
                console.log(error.text);
            });
    }
    // Faqs
    const data = {
        title: "",
        rows: [
            {
                "title": "WHY CHOOSE ROCKET CHIMNEY?",
                "content": "Rocket Chimney brings over 22 years of experience, trusted service, and certified chimney professionals. We use advanced tools and proven techniques to ensure your chimney and fireplace are safe, clean, and fully functional. Customer satisfaction and home safety are always our top priorities."
            },
            {
                "title": "WHAT CHIMNEY SERVICES DO YOU OFFER?",
                "content": "We provide chimney sweeping, inspections, repairs, liner installation, crown and cap repairs, fireplace maintenance, and more. Whether you're dealing with creosote buildup or structural issues, Rocket Chimney has you covered."
            },
            {
                "title": "HOW MUCH DO YOUR SERVICES COST?",
                "content": "Our standard chimney inspection starts at $69. Full chimney cleanings start at $99. We also offer free consultations for repairs or upgrades. You'll receive transparent pricing and no hidden fees."
            },
            {
                "title": "CAN YOU CLEAN AND REPAIR DURING THE SAME VISIT?",
                "content": "Yes! Our technicians are fully equipped to perform chimney cleaning and handle most repairs on the same day. If your inspection reveals any issues, we’ll walk you through the solutions and can often fix them immediately."
            },
            {
                "title": `DO YOU SERVICE ${CitiesData && CitiesData.City ? CitiesData.City.toUpperCase() : "MY AREA"} AND NEARBY TOWNS?`,
                "content": `Absolutely. We proudly serve ${CitiesData && CitiesData.City ? CitiesData.City : "your area"} and surrounding communities within a 75-mile radius. No matter where you are, Rocket Chimney is here to help keep your home safe and warm.`
            },
            {
                "title": "HOW DO I BOOK A CHIMNEY SERVICE?",
                "content": `Booking is easy! Call us at <a href='tel:${CitiePhone}'>${CitiePhone}</a> or fill out our <a href='#book'>online booking form</a>. We'll confirm your appointment quickly and send a technician to assist you at your convenience.`
            },
            {
                "title": "HOW OFTEN SHOULD A CHIMNEY BE CLEANED?",
                "content": "We recommend chimney cleaning at least once a year, especially before winter. Regular maintenance reduces fire risk, improves fireplace efficiency, and helps prevent structural damage."
            },
            {
                "title": "WHAT ARE THE SIGNS MY CHIMNEY NEEDS SERVICE?",
                "content": "Look for signs like smoke backing into your home, strong odors, visible soot buildup, damaged caps or bricks, and slow-burning fires. These may indicate blockages or damage that require immediate attention."
            }
        ]
    };

    const styles = {
        bgColor: '#FBF6E9',
        titleTextColor: '#182d43',
        titleTextSize: '18px',
        rowTitleColor: '#182d43',
        rowTitleTextSize: '19px',
        rowContentColor: '#242424',
        rowContentTextSize: '17px',
        // rowContentTextWeight: '600',
        rowContentPaddingTop: '10px',
        rowContentPaddingBottom: '10px',
        rowContentPaddingLeft: '5px',
        rowContentPaddingRight: '5px',
        arrowColor: "",
        //transitionDuration: "1s",
        // timingFunc: "ease"
    };
    const config = {
        // animate: true,
        // arrowIcon: "V",
        // tabFocus: true
        openOnload: 0,
    };

    useEffect(() => {
        (async () => {
            try {
                const searchKeyword = `I need from you 32 words about the "${url.searchParams.get('kd')}" how we "Rocket AirCare" can help our clients with that kind of service, give me that as json file: title 3 words (include in the title words from the keyword, remove null and Rocket AirCare from title)(if no keywords just do for chimney sweep) and body`
                const resChat = await fetch(`https://genesis-platforms-8157acd2d107.herokuapp.com/api/GenesisOpenAi_Landing_Pages_Content_Creating`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        prompt: searchKeyword
                    })
                })
                const dataChat = await resChat.json()
                console.log(dataChat.content)
                setResponse(JSON.parse(dataChat.content))
            } catch (error) {
                console.log(error);
            }

            const getDerivedStateFromError = (error) => {
                console.log("123123");
                return { hasError: true };
            }
            const dsad = (error, errorInfo) => {
                console.log("123123");
            }
        })();
    }, []);
    return (
        <div className="Chimney ServicesPage" id="homepage">
<Helmet>
    <title>{ServiceName} | Rocket Air Care | 866-950-4606</title>
    <meta name="title" property="title" content={`${ServiceName} | Rocket Air Care | 866-950-4606`} data-react-helmet="true" />
    <meta name="og:title" property="og:title" content={`${ServiceName} | Rocket Air Care`} data-react-helmet="true" />
    <meta name="og:locale" property="og:locale" content="en_US" data-react-helmet="true" />
    <meta name="og:type" property="og:type" content="website" data-react-helmet="true" />
    <meta name="og:image" property="og:image" content="https://www.rocketaircare.com/og.jpg" data-react-helmet="true" />
    <meta name="og:url" property="og:url" content={Content ? `https://www.rocketaircare.com${Content.Path}${TheCity ? "/" + TheCity.url : ""}` : "https://www.rocketaircare.com/services"} data-react-helmet="true" />
    <link rel="canonical" href={Content ? `https://www.rocketaircare.com${Content.Path}${TheCity ? "/" + TheCity.url : ""}` : "https://www.rocketaircare.com/services"} />
    <meta name="description" content={`${ServiceDesc} Call Rocket Air Care at 866-950-4606.`} data-react-helmet="true" />
    <meta name="og:description" property="og:description" content={ServiceDesc} data-react-helmet="true" />
    <meta name="og:site_name" property="og:site_name" content="Rocket Air Care" data-react-helmet="true" />
    <meta name="keywords" content={`${ServiceName}, Rocket Air Care, air duct cleaning, HVAC repair, chimney sweep, dryer vent cleaning, roof repair, home services, ${CitiesData && CitiesData.City ? CitiesData.City : "near me"}`} data-react-helmet="true" />
    <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
    {Content && (
        <script type="application/ld+json">{JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",
            "name": Content.Title,
            "serviceType": Content.Title,
            "description": Content.Full,
            "url": `https://www.rocketaircare.com${Content.Path}${TheCity ? "/" + TheCity.url : ""}`,
            "provider": {
                "@type": "HomeAndConstructionBusiness",
                "name": "Rocket Air Care",
                "telephone": "+1-866-950-4606",
                "url": "https://www.rocketaircare.com",
                "priceRange": "$$",
                "image": "https://www.rocketaircare.com/og.jpg",
                "aggregateRating": { "@type": "AggregateRating", "ratingValue": "4.9", "reviewCount": "500" }
            },
            "areaServed": { "@type": "Country", "name": "United States" }
        })}</script>
    )}
    {Content && (
        <script type="application/ld+json">{JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
                { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://www.rocketaircare.com/" },
                { "@type": "ListItem", "position": 2, "name": "Services", "item": "https://www.rocketaircare.com/services" },
                { "@type": "ListItem", "position": 3, "name": Content.Title, "item": `https://www.rocketaircare.com${Content.Path}${TheCity ? "/" + TheCity.url : ""}` }
            ]
        })}</script>
    )}
</Helmet>

            {/* MainBanner */}
            <div className="MainBanner" >
                <div className="MainBannerLeft">
                    <div className="MainBannerLeftRight">

                        <img className="bannerlogopng" src={require(`../../ImagesLogos/Logo1.png`)} />

                        <h1>{ServiceName} — Call Rocket Air Care</h1>
                        <h4>Top-Rated <b>{ServiceName}</b> in {CitiesData && CitiesData.City ? CitiesData.City.toUpperCase() : "Your Area"}</h4>
                        <h2>{ServiceDesc} Give us a call at <span>{CitiePhone}</span> to schedule your service.</h2>
                        <h3><img src={require(`../../Images/check.png`)} />Affortable Pricing & No Hidden Fees</h3>
                        <h3><img src={require(`../../Images/check.png`)} />Licensed, Bonded, Insured!</h3>
                        <h3><img src={require(`../../Images/check.png`)} />Fully stocked trucks</h3>
                        <h3><img src={require(`../../Images/check.png`)} />1800+ 5-Star Reviews</h3>
                        <div className="MainBannerLeftButtons">
                            <a href={`tel:${CitiePhone}`}>Call Us Now!</a>
                            <a href={`tel:${CitiePhone}`}>{CitiePhone}<img src={require(`../../Images/telephone.png`)} /></a>
                        </div>
                        <div className="MainBannerLeftRated" >
                            <h3>Rated 5 on Google</h3>
                            <span>
                                <h4>5</h4>
                                <img fetchpriority="low" src={require(`../../Images/Google.png`)} />
                            </span>
                        </div>
                    </div>
                    <div className="MainBannerLeftLeft">
                        <BookAnAppointment CitiesData={CitiesData} CitiePhone={CitiePhone} />
                    </div>

                </div>
                <div className="MainBannerImg">
                    <img src={require(`../../ImagesLogos/logobanner.png`)} />
                </div>
            </div>
            {/* Service-specific SEO content (unique per /service/:slug) */}
            {Content && Content.Content && (
                <div className="ServicesPageContent">
                    <div className="ServicesPageContentInner">
                        {parse(Content.Content)}
                    </div>
                </div>
            )}
            {/* ChimneyReviews */}
            <div className="ChimneyReviews" id="reviews">
                <h1>Read Our Latest 5-Star Reviews</h1>
                <div className="ChimneyReviewsList">
                    <img className="bannerlogopng" src={require(`../../Images/chimneyreview1.png`)} />
                    <img className="bannerlogopng" src={require(`../../Images/chimneyreview2.png`)} />
                    <img className="bannerlogopng" src={require(`../../Images/chimneyreview3.png`)} />
                </div>
            </div>
            {/* ChimneyBenefits */}
            <div className="ChimneyBenefits">
                <h1>Benefits of Professional <span>Chimney Services</span></h1>

                <div className="ChimneyBenefitsBox">
                    <div className="ChimneyBenefitsBoxImg">
                        <img src={require(`../../Images/ben2.png`)} alt="Smoke Problems" />
                    </div>
                    <div className="ChimneyBenefitsBoxBox">
                        <h2>Smoke Coming Into The Room?</h2>
                        <h3>Smoke backup could indicate blockages, poor draft, or damper issues. Our team performs thorough inspections and restores airflow so your chimney vents smoke properly and safely.</h3>
                    </div>
                </div>

                <div className="ChimneyBenefitsBox">
                    <div className="ChimneyBenefitsBoxImg">
                        <img src={require(`../../Images/ben3.png`)} alt="Structural Damage" />
                    </div>
                    <div className="ChimneyBenefitsBoxBox">
                        <h2>Noticed Cracks or Water Leaks?</h2>
                        <h3>Our masonry repair, crown sealing, and waterproofing services prevent water intrusion and fix brick or flue damage, preserving your chimney’s structural integrity.</h3>
                    </div>
                </div>

                <div className="ChimneyBenefitsBox">
                    <div className="ChimneyBenefitsBoxImg">
                        <img src={require(`../../Images/ben1.png`)} alt="Fire Hazard" />
                    </div>
                    <div className="ChimneyBenefitsBoxBox">
                        <h2>Concerned About Fire Safety?</h2>
                        <h3>Creosote buildup, faulty liners, and missing chimney caps can all increase fire risk. Our sweeping, relining, and cap installation services ensure safer fireplace operation.</h3>
                    </div>
                </div>

                <div className="ChimneyBenefitsBox">
                    <div className="ChimneyBenefitsBoxImg">
                        <img src={require(`../../Images/ben4.png`)} alt="Performance Issues" />
                    </div>
                    <div className="ChimneyBenefitsBoxBox">
                        <h2>Poor Fireplace Performance?</h2>
                        <h3>Draft problems, broken dampers, or outdated components can affect performance. We inspect and repair all parts of your chimney system to improve efficiency and comfort.</h3>
                    </div>
                </div>

                <h4>INVEST IN THE LONG-TERM SAFETY AND PERFORMANCE OF YOUR <span>CHIMNEY SYSTEM</span>. SCHEDULE YOUR SERVICE WITH ROCKET CHIMNEY TODAY!</h4>

                <div className="ChimneyBenefitsbutn">
                    <a href={`tel:${CitiePhone}`}>{CitiePhone}<img src={require(`../../Images/telephone.png`)} /></a>
                    <a href='#book'>SCHEDULE <span>&nbsp;ONLINE</span><img src={require(`../../Images/book.png`)} alt="Chimney Repair | Chimney Inspection | Fireplace Safety | Full Service Chimney" /></a>
                </div>
            </div>
            {/* MainBanner2Top2 */}
            <div className="MainBanner2Top2">
                <div className="MainBanner2TopBoxMenuShadow1"></div>
                <div className="MainBanner2TopBoxMenu">
                    <a className="MainBanner2TopBoxBox">
                        <img src={require(`../../Images/chimnneyinspection.webp`)} alt="Chimney Cleaning" />
                        <div className="MainBanner2TopBoxBoxBox">
                            <h3>CHIMNEY CLEANING</h3>
                            <h2><img src={require(`../../Images/check.png`)} />Creosote & Soot Removal</h2>
                            <h2><img src={require(`../../Images/check.png`)} />Fireplace Cleaning</h2>
                            <h2><img src={require(`../../Images/check.png`)} />Odor Elimination</h2>
                            <h2><img src={require(`../../Images/check.png`)} />Improved Airflow</h2>
                        </div>
                    </a>

                    <a className="MainBanner2TopBoxBox">
                        <img src={require(`../../Images/chimneyrepair.jpg`)} alt="Chimney Repair" />
                        <div className="MainBanner2TopBoxBoxBox">
                            <h3>CHIMNEY REPAIR</h3>
                            <h2><img src={require(`../../Images/check.png`)} />Cracked Flue Repair</h2>
                            <h2><img src={require(`../../Images/check.png`)} />Crown & Cap Repair</h2>
                            <h2><img src={require(`../../Images/check.png`)} />Chimney Repointing</h2>
                            <h2><img src={require(`../../Images/check.png`)} />Smoke Leak Sealing</h2>
                        </div>
                    </a>

                    <a className="MainBanner2TopBoxBox">
                        <img src={require(`../../Images/chimneyliner.jpg`)} alt="Chimney Liner" />
                        <div className="MainBanner2TopBoxBoxBox">
                            <h3>CHIMNEY LINER SERVICE</h3>
                            <h2><img src={require(`../../Images/check.png`)} />Liner Installation</h2>
                            <h2><img src={require(`../../Images/check.png`)} />Relining Services</h2>
                            <h2><img src={require(`../../Images/check.png`)} />Stainless Steel Liners</h2>
                            <h2><img src={require(`../../Images/check.png`)} />Flue Protection</h2>
                        </div>
                    </a>

                    <a className="MainBanner2TopBoxBox">
                        <img src={require(`../../Images/fireplacerepair.jpg`)} alt="Fireplace Services" />
                        <div className="MainBanner2TopBoxBoxBox">
                            <h3>FIREPLACE SERVICES</h3>
                            <h2><img src={require(`../../Images/check.png`)} />Firebox Inspection</h2>
                            <h2><img src={require(`../../Images/check.png`)} />Damper Repair</h2>
                            <h2><img src={require(`../../Images/check.png`)} />Smoke Chamber Cleaning</h2>
                            <h2><img src={require(`../../Images/check.png`)} />Masonry Touch-Ups</h2>
                        </div>
                    </a>
                </div>
                <div className="MainBanner2TopBoxMenuShadow2"></div>
            </div>
            {/* ChimneyWeondawy */}
            <div className="ChimneyWeondawy">
                <img src={require(`../../ImagesLogos/logobanner2.png`)} alt="Air Duct Cleaning" />
                <h1>Stay calm, we're coming to you!</h1>

            </div>
            {/* Chimneybefore */}
            <div className="ChimneyBefore">
                <div className="ChimneyBeforeLeft">
                    <h1>THE IMPORTANCE OF CHIMNEY CLEANING</h1>
                    <h2>Protect Your Home, Prevent Fires, and Breathe Safer</h2>
                    <h3>Your chimney plays a vital role in safely venting smoke and harmful gases out of your home. Over time, creosote, soot, and debris build up inside your flue, increasing the risk of chimney fires and poor airflow. Blockages can also cause dangerous fumes like carbon monoxide to back up indoors. Regular chimney cleaning ensures proper ventilation, enhances fireplace performance, and protects your family from hidden fire and health hazards. Don’t take chances—schedule a professional chimney sweep today!</h3>

                    <h2>Fire Safety Starts With A Clean Chimney</h2>
                    <h3>Chimney maintenance is not just about keeping things tidy—it’s essential for your safety. A neglected chimney can harbor creosote, nests, or moisture damage that may compromise the structure or function. Cleaning and inspecting your chimney helps prevent costly repairs, improves indoor air quality, and ensures your fireplace is ready when you need it. Keep your home safe, warm, and worry-free by making chimney care a regular part of your home maintenance plan.</h3>

                    <h4>Booking with Rocket AirCare is simple! Call us at <a href='tel:${CitiePhone}'>{CitiePhone}</a> or complete our <a href='#book'>online booking form</a>. Our team will confirm your appointment and be ready to assist you at your convenience.</h4>
                </div>
                <div className="ChimneyBeforeBox">
                    <ReactCompareImage leftImage={img22} rightImage={img23} />
                </div>
            </div>
            {/* HomePageGoogleBen */}
            <div className="HomePageGoogleBen">
                <div className="HomePageGoogleBenLEFT">
                    <img fetchpriority="low" src={require(`../../Images/Before1.jpeg`)} />
                </div>
                <div className="HomePageGoogleBenRIGHT">
                    <h1>ROCKET BENEFITS</h1>
                    <div className="HomePageGoogleBenRIGHTList">
                        <div className="HomePageGoogleBenRIGHTListBox">
                            <img src={require(`../../Images/check.png`)} />
                            <h2>
                                Highly Trained & Certified Technicians
                                <h3>- Our Technicians completed more than 2,500 hours of training in 2023</h3>
                                <h3>- Our Technicians complete 45+ hours yearly of weekly skills training</h3>
                            </h2>
                        </div>
                        <div className="HomePageGoogleBenRIGHTListBox">
                            <img src={require(`../../Images/check.png`)} />
                            <h2>
                                Fast Response Time
                                <h3>- 24/7 emergency appointments available</h3>
                            </h2>
                        </div>
                        <div className="HomePageGoogleBenRIGHTListBox">
                            <img src={require(`../../Images/check.png`)} />
                            <h2>
                                Satisfaction Guaranteed
                                <h3>- 1,800+ five-star reviews</h3>
                            </h2>
                        </div>
                        <div className="HomePageGoogleBenRIGHTListBox">
                            <img src={require(`../../Images/check.png`)} />
                            <h2>Fully Licensed & Insured</h2>
                        </div>
                        <div className="HomePageGoogleBenRIGHTListBox">
                            <img src={require(`../../Images/check.png`)} />
                            <h2>Friendly Customer Service</h2>
                        </div>
                    </div>
                </div>
            </div>
            {/* ChimneyGoodBY */}
            <div className="ChimneyGoodBY">
                <h1>SAY GOODBYE TO CREOSOTE AND SOOT BUILDUP</h1>
                <div className="HomePageGoogleFAQBorder"></div>
                <h2>Enjoy safer fires and cleaner air with our expert chimney cleaning services.</h2>
                <div className="ChimneyGoodBYList">
                    <img src={require(`../../Images/damperrepair.webp`)} />
                    <img src={require(`../../Images/Chimney1.jpeg`)} />
                    <img src={require(`../../Images/Chimney6.jpeg`)} />
                    <img src={require(`../../Images/69.jpg`)} />
                </div>
            </div>
            {/* MainBanner */}
            <div className="ChimneyBook">
                <div className="MainBannerLeftRight">
                    <h1>Book Your Chimney and Fireplace Services Online Now in {CitiesData && CitiesData.City ? CitiesData.City.toUpperCase() : "Your Area"}</h1>
                    <h4>Top-Rated <b>Chimney and Fireplace Service</b></h4>
                    <h2>Rocket Air Care: Your Trusted Chimney and Fireplace Services Team in <b>{CitiesData && CitiesData.City ? CitiesData.City.toUpperCase() : "Your Area"}</b>. 📅 Schedule Your Appointment Online in less then a Minute</h2>
                    <h3><img src={require(`../../Images/check.png`)} /> Affordable Pricing & No Hidden Fees – Book Online Today!</h3>
                    <h3><img src={require(`../../Images/check.png`)} /> Licensed, Bonded, & Insured Professionals Ready to Serve You</h3>
                    <h3><img src={require(`../../Images/check.png`)} /> Fully Stocked Trucks for Next-Day Service – Schedule Now!</h3>
                    <h3><img src={require(`../../Images/check.png`)} /> Trusted by 1800+ 5-Star Reviews – Join Our Happy Customers!</h3>
                    <div className="MainBannerLeftButtons" id="book">
                        <a href={`tel:${CitiePhone}`}>Call Us Now!</a>
                        <a href={`tel:${CitiePhone}`}>{CitiePhone}<img src={require(`../../Images/telephone.png`)} /></a>
                    </div>
                    <div className="MainBannerLeftRated">
                        <h3>Rated 5 on Google</h3>
                        <span>
                            <h4>5</h4>
                            <img fetchpriority="low" src={require(`../../Images/Google.png`)} />
                        </span>
                    </div>
                </div>
                <div className="MainBannerLeftLeft">
                    <BookAnAppointment CitiesData={CitiesData} CitiePhone={CitiePhone} />
                </div>

            </div>
            {/* ChimneyHowit work */}
            <div className="ChimneyHowIt">
                <h1>How It Works</h1>
                <div className="HomePageGoogleFAQBorder"></div>
                <h2>All It Takes Is Three Easy Steps</h2>
                <div className="ChimneyHowItList">
                    <div className="ChimneyHowItListBox">
                        <img className="bannerlogopng" src={require(`../../Images/howit1.png`)} />
                        <h3>STEP 1</h3>
                        <h4>Call Our Office</h4>
                        <h5>Give us a call at <a href={`tel:${CitiePhone}`}>{CitiePhone}</a> to speak with one of our chimney experts and schedule your appointment.</h5>
                    </div>
                    <div className="ChimneyHowItListBox">
                        <img className="bannerlogopng" src={require(`../../Images/howit2.png`)} />
                        <h3>STEP 2</h3>
                        <h4>On-Site Chimney Inspection</h4>
                        <h5>We’ll dispatch a certified chimney technician to inspect, assess, and explain any issues found during the visit.</h5>
                    </div>
                    <div className="ChimneyHowItListBox">
                        <img className="bannerlogopng" src={require(`../../Images/howit3.png`)} />
                        <h3>STEP 3</h3>
                        <h4>Clean & Restore</h4>
                        <h5>Our team will professionally clean your chimney and perform any needed services to restore safety and function.</h5>
                    </div>
                </div>
                <h6>Give us a call at <a href={`tel:${CitiePhone}`}>{CitiePhone}</a> to get started.</h6>
            </div>
            {/* MainBanner2Top2 */}
            <div className="ChimneyServices" id="ourservices">
                <div className="MainBanner2TopBoxMenu">
                    <a className="MainBanner2TopBoxBox">
                        <img src={require(`../../Images/Chimney6.jpeg`)} alt="Chimney Cleaning" />
                        <div className="MainBanner2TopBoxBoxBox">
                            <div className="MainBanner2TopBoxBoxBoxBox">
                                <h3>CHIMNEY CLEANING</h3>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Creosote & Soot Removal</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Odor Elimination</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Improved Draft Performance</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Fire Risk Reduction</h2>
                            </div>
                            <h4>Protect your home with Rocket Chimney’s professional chimney cleaning services. Over time, creosote and soot build up, increasing the risk of chimney fires and affecting air quality. Our trained technicians use specialized tools to remove buildup and improve airflow. Keep your chimney clean, safe, and ready for every season. Call Rocket Chimney today and schedule your full-service sweep!</h4>
                        </div>
                    </a>

                    <a className="MainBanner2TopBoxBox">
                        <img src={require(`../../Images/chimneyrepair.jpg`)} alt="Chimney Repair" />
                        <div className="MainBanner2TopBoxBoxBox">
                            <div className="MainBanner2TopBoxBoxBoxBox">
                                <h3>CHIMNEY REPAIR</h3>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Cracked Flue Repair</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Crown & Cap Repair</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Water Leak Fixes</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Masonry Restoration</h2>
                            </div>
                            <h4>Don’t let minor chimney damage turn into a costly issue. Rocket Chimney specializes in all types of chimney repairs—from cracked flues to water leaks and deteriorating masonry. Our certified team restores structural integrity and ensures safe fireplace use. Call Rocket Chimney now for fast, reliable repair services and extend the life of your chimney!</h4>
                        </div>
                    </a>

                    <a className="MainBanner2TopBoxBox">
                        <img src={require(`../../Images/chimneyliner.jpg`)} alt="Chimney Liner Services" />
                        <div className="MainBanner2TopBoxBoxBox">
                            <div className="MainBanner2TopBoxBoxBoxBox">
                                <h3>CHIMNEY LINER SERVICES</h3>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Liner Installation</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Relining Solutions</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Flue Protection</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Code Compliance Upgrades</h2>
                            </div>
                            <h4>A damaged or missing liner can pose serious fire and safety hazards. Rocket Chimney offers full-service liner installation and relining using stainless steel or heat-resistant materials. Improve chimney performance and keep your home up to code. Call us today to upgrade or replace your chimney liner with confidence!</h4>
                        </div>
                    </a>

                    <a className="MainBanner2TopBoxBox">
                        <img src={require(`../../Images/fireplacebanner.jpg`)} alt="Fireplace Services" />
                        <div className="MainBanner2TopBoxBoxBox">
                            <div className="MainBanner2TopBoxBoxBoxBox">
                                <h3>FIREPLACE SERVICES</h3>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Firebox Cleaning</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Damper Repair</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Smoke Chamber Service</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Fireplace Restoration</h2>
                            </div>
                            <h4>Enhance your home’s warmth and charm with Rocket Chimney’s fireplace maintenance services. We clean, inspect, and repair fireboxes, dampers, and more to ensure your fireplace is safe and functional. Whether it’s a small touch-up or a complete restoration, we’re here to help. Call Rocket Chimney and enjoy a safer, cozier fire season.</h4>
                        </div>
                    </a>

                    <a className="MainBanner2TopBoxBox">
                        <img src={require(`../../Images/chimneycap.jpeg`)} alt="Chimney Cap Services" />
                        <div className="MainBanner2TopBoxBoxBox">
                            <div className="MainBanner2TopBoxBoxBoxBox">
                                <h3>CHIMNEY CAP SERVICES</h3>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Cap Installation</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Cap Repair & Replacement</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Animal & Debris Protection</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Weatherproofing Solution</h2>
                            </div>
                            <h4>Chimney caps are your first line of defense against rain, animals, and debris entering your chimney. Rocket Chimney installs and repairs all types of chimney caps to keep your system protected and functioning properly. Call today to ensure your chimney stays covered, clean, and safe in all weather conditions.</h4>
                        </div>
                    </a>

                    <a className="MainBanner2TopBoxBox">
                        <img src={require(`../../Images/Chimney1.jpeg`)} alt="Chimney Masonry Services" />
                        <div className="MainBanner2TopBoxBoxBox">
                            <div className="MainBanner2TopBoxBoxBoxBox">
                                <h3>CHIMNEY MASONRY</h3>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Brick & Mortar Repair</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Tuckpointing & Repointing</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Chimney Rebuilds</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Crown Repair & Sealing</h2>
                            </div>
                            <h4>Restore the strength and beauty of your chimney with expert masonry services from Rocket Chimney. We handle everything from minor mortar fixes to full chimney rebuilds. Whether your chimney is cracked, crumbling, or leaking—our skilled masons ensure lasting results with precision and care. Call us today for a detailed assessment and professional restoration.</h4>
                        </div>
                    </a>

                    <a className="MainBanner2TopBoxBox">
                        <img src={require(`../../Images/chimnneyinspection.webp`)} alt="Chimney Inspection Services" />
                        <div className="MainBanner2TopBoxBoxBox">
                            <div className="MainBanner2TopBoxBoxBoxBox">
                                <h3>CHIMNEY INSPECTION</h3>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Level 1, 2 & 3 Inspections</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Video Camera Scans</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Fire Hazard Detection</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Annual Safety Reports</h2>
                            </div>
                            <h4>Keep your home safe with a professional chimney inspection from Rocket Chimney. Our certified technicians perform detailed assessments to identify creosote buildup, structural issues, or fire hazards. Whether it’s your annual check-up or a real estate requirement, we deliver clear, honest evaluations you can trust. Book your inspection today!</h4>
                        </div>
                    </a>

                    <a className="MainBanner2TopBoxBox">
                        <img src={require(`../../Images/69.jpg`)} alt="Chimney Maintenance Services" />
                        <div className="MainBanner2TopBoxBoxBox">
                            <div className="MainBanner2TopBoxBoxBoxBox">
                                <h3>CHIMNEY MAINTENANCE</h3>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Annual Cleaning Plans</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Seasonal Inspections</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Leak Prevention</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Performance Optimization</h2>
                            </div>
                            <h4>Routine chimney maintenance is key to preventing major issues and ensuring safe fireplace use. Rocket Chimney offers customized plans that include inspections, cleaning, minor repairs, and seasonal upkeep. Stay ahead of costly repairs—contact us today to schedule regular chimney maintenance that fits your needs and budget.</h4>
                        </div>
                    </a>

                    <a className="MainBanner2TopBoxBox">
                        <img src={require(`../../Images/chimneyleak.jpg`)} alt="Chimney Leak Repair Services" />
                        <div className="MainBanner2TopBoxBoxBox">
                            <div className="MainBanner2TopBoxBoxBoxBox">
                                <h3>CHIMNEY LEAK REPAIR</h3>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Flashing Repair & Replacement</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Crown Sealing & Rebuilding</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Waterproofing Applications</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Leak Detection & Resolution</h2>
                            </div>
                            <h4>Water leaks can cause serious damage to your chimney and home. At Rocket Chimney, we specialize in identifying the source of leaks and applying long-lasting solutions—whether it's flashing failure, cracked crowns, or masonry deterioration. Schedule your chimney leak inspection today and protect your property from costly water damage.</h4>
                        </div>
                    </a>

                </div>
            </div>
            {/* MainBanner4 */}
            <div className="MainBanner4">
                <div className="MainBanner4Right">
                    <h1>Our Comprehensive Chimney Services</h1>
                    <h2>At Rocket Chimney, we provide a full range of chimney and fireplace services to ensure your home is safe, warm, and efficient. From chimney sweeping and inspection to repairs, relining, and cap installation, our certified technicians are equipped with the latest tools to handle any issue. We focus on preventing fire hazards, improving ventilation, and maintaining structural integrity. Trust Rocket Chimney to keep your fireplace and chimney in top shape year-round.</h2>
                    <div className="MainBafnner4RightBenefits">
                        <a>Chimney cleaning</a>
                        <a>Professional chimney sweeping</a>
                        <a>Chimney inspection</a>
                        <a>Chimney repair</a>
                        <a>Chimney liner installation</a>
                        <a>Chimney cap repair & install</a>
                        <a>Smoke chamber cleaning</a>
                        <a>Fireplace repair</a>
                        <a>Draft issue resolution</a>
                        <a>Creosote removal</a>
                        <a>Animal removal from chimney</a>
                        <a>Waterproofing & leak repair</a>
                        <a>Masonry restoration</a>
                        <a>Chimney crown repair</a>
                        <a>Chimney damper repair</a>
                        <a>Fire hazard prevention</a>
                        <a>Certified chimney inspections</a>
                        <a>Same-day chimney service</a>
                        <a>Licensed and insured technicians</a>
                        <a>Residential fireplace services</a>
                    </div>
                </div>
            </div>
            {/* HomePageGoogleFAQ */}
            <div className="HomePageGoogleFAQ">
                <h1>ABOUT OUR {CitiesData && CitiesData.City ? CitiesData.City.toUpperCase() : ""} LOCATION</h1>
                <div className="HomePageGoogleFAQBorder"></div>
                <div className="HomePageGoogleFAQTop">
                    <div className="HomePageGoogleFAQTopLeft">
                        <h2>PROUDLY SERVING OUR LOCAL COMMUNITY</h2>
                        <div className="HomePageGoogleFAQBorder"></div>
                        <h3>At Rocket Chimney, we are proud to bring professional chimney and fireplace services to the {CitiesData && CitiesData.City ? CitiesData.City : ""} area. For over 22 years, we’ve helped homeowners protect their families and properties by offering trusted chimney inspections, cleanings, and repairs. Our experienced technicians use industry-best tools and techniques to ensure your chimney is safe, efficient, and ready to use year-round.</h3>
                        <div className="MainBannerLeftButtons">
                            <a href={`tel:${CitiePhone}`}>Call Us Now!<img fetchpriority="low" src={require(`../../Images/telephone.png`)} /></a>
                            <a href='#book'>SCHEDULE ONLINE<img src={require(`../../Images/book.png`)} alt="Chimney Sweep Cleaning Near Me Rocket Chimney" /></a>
                        </div>
                    </div>
                    <div className="HomePageGoogleFAQTopRight">
                        <img src={require(`../../ImagesLogos/logobanner.png`)} />
                    </div>
                </div>
                <h1>FREQUENTLY ASKED QUESTIONS</h1>
                <div className="HomePageGoogleFAQBorder"></div>
                <div className="MainBanner4FaqMore">
                    <Faq
                        data={data}
                        styles={styles}
                        config={config}
                    />
                </div>
            </div>
        </div>
    )
}

